import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Vat = ApplicationRecord.extend({
  attrs: {
    name: attr({ type: String }),
    rate: attr({ type: Number }),
    description: attr({ type: String })
  },
  static: {
    endpoint: '/vats',
    jsonapiType: 'shop-vats',
  },
});

export default Vat;
